import { Upload } from 'antd'
import styled from 'styled-components'
const UploadMediaStyled = styled(Upload)`
  width: ${({ width }) => width || '100%'};
`

export default UploadMediaStyled
